module.exports = __webpack_public_path__ + "static/media/hall-P6.c656b3f5.svg";